export default {
  all_conglomerates: 'Todos los Conglomerados',
  create: 'Crear Conglomerado',
  edit: 'Editar Conglomerado',
  conglomerate_name: 'Nombre del Conglomerado',
  country: 'País',
  status: 'Estatus',
  active: 'Activo',
  inactive: 'Inactivo',
  status_created: 'Vigente',
  status_inactive: 'Histórico',
  total_schools: 'Total de Colegios',
  total_licenses: 'Total de Licencias',
  actions: 'Acciones',

  associated_schools: 'Sedes asociadas',
  school_name: 'Nombre del colegio',
  unlink_school: 'Desvincular sede',
  unlink_confirmation: '¿Desvincular esta sede del conglomerado?',
  unlink_success: 'Sede desvinculada',

  agreement: 'Acuerdo',
  current_agreement: 'Acuerdo vigente',
  agreement_history: 'Historial de acuerdos',
  agreement_name: 'Nombre del Acuerdo',
  agreement_type: 'Tipo',
  agreement_total_licenses: 'Total de Licencias',
  agreement_dates: 'Fechas',
  create_agreement: 'Crear Acuerdo',
  edit_agreement: 'Editar Acuerdo',
  edit_agreement_hint:
    'Si cambias ambas fechas o el tipo de acuerdo, se creara un nuevo registro y el actual pasara a historico.',

  start_date: 'Fecha de Inicio',
  end_date: 'Fecha de Fin',
  licenses: 'licencias',
  no_name: 'Sin nombre',
  no_agreements: 'No hay acuerdos registrados',
  no_agreements_description: 'Crea un acuerdo para definir licencias y fechas de vigencia.',
  expired: 'Vencido',

  type_demo: 'Demo',
  type_trial: 'Trial',
  type_client: 'Cliente',

  save_success: 'Cambios guardados',
  create_success: 'Conglomerado creado',
  error_loading: 'Error al cargar conglomerados',
  error_saving: 'Error al guardar',
  error_validation: 'Revisa los campos requeridos',
};
